import React, { PureComponent } from "react";
import { Query } from "react-apollo";
import { CURRENT_USER_QUERY } from "../me/me";
import SignIn from "../signin-form/sign-in-form";
import PageHeading from "../../components/page-heading/page-heading";
import Head from "../../components/head-data/head-data";

import "./request-sign-in.scss";

class RequestSignIn extends PureComponent {
  render() {
    return (
      <>
        <Head noIndex />
        <Query query={CURRENT_USER_QUERY} ssr={false}>
          {({ data, loading }) => {
            if (loading) return <p>loading...</p>;
            if (!data?.me || !this.props.children) {
              return (
                <>
                  <PageHeading
                    title={"Please sign in"}
                    src="https://res.cloudinary.com/djrpmnbbi/image/upload/f_auto,q_auto/v1614705745/website-assets/general-site-images/community.jpg"
                    alt="startup whiteboard"
                  />
                  <div className="request-sign-in">
                    <div className="request-sign-in__inner">
                      <SignIn />
                    </div>
                  </div>
                </>
              );
            }

            return this.props.children;
          }}
        </Query>
      </>
    );
  }
}

export default RequestSignIn;
